/*  View Class - Prototype Based
 *  Justin Bevan
 *
 *--------------------------------------------------------------------------*/

var View =
{
    /**
     * Data
     */
    data:{},

    /**
     * Opened Quick Edit Boxes
     *
     */
    openedQuickEditBoxes: [],

    /**
     * Constructor
     *
     */
    initialize: function(isAdmin)
    {
        this.data = {
            lastDisplayQuickEdit    : 0,
            lastSchedulerBoard      : 0,
            modelOutputTimeFormat   : 'date-time-date',
            schedulerBoardModal     : {}
        };

        this.isAdmin                    = (!!(typeof isAdmin != 'undefined' && isAdmin));
        this.displaySpinner             = {};
        this.openedQuickEditBoxes       = [];
        this.tableOutput                = {};

        // Set spinner options
        this.spinOpts =
        {
            color: "#00B0F0"
        }
    },

    /**
     * Run Request
     *
     * @param {String} url
     * @param {String} type
     * @param {Object|FormData} params
     * @param {Boolean} asynchronous
     * @param {Function} onComplete
     * @param {Optional|Object} options
     * @returns {*}
     */
    runRequest: function(url, type, params, asynchronous, onComplete, options)
    {
        // Set response variable
        var response, responseText, parsedJson,
            async   = asynchronous === true,
            context = this;

        var ajaxOpts = {
            'async'     : async,
            'type'      : type,
            'dataType'  : 'json',
            'data'      : params,
            'url'       : url,
            'complete': function(data)
            {
                response = data;

                if(typeof onComplete == 'function' && response && async)
                {
                    responseText    = context.IsJsonString(response.responseText) ? response.responseText : null;
                    parsedJson      = jQuery.parseJSON(responseText);

                    if(parsedJson && _.isObject(parsedJson) && parsedJson.responseType && parsedJson.errorClass && parsedJson.errorClass == 'TokenMismatchException')
                    {
                        var msg = parsedJson.message && parsedJson.message !== '' ? parsedJson.message : 'Click ok to login';

                        swal({
                            type: 'error',
                            title: 'Your login session has expired',
                            text: msg,
                            buttons: true,
                            confirmButtonText: 'Refresh'
                        }).then(function()
                        {
                            window.loadUrl(window.location.href);
                        }).catch(swal.noop);

                        return true;
                    }
                    else
                    {
                        onComplete(response, parsedJson);
                    }
                }
            }
        };

        if(params instanceof FormData)
        {
            ajaxOpts['contentType'] = false;
            ajaxOpts['processData'] = false;
        }

        if(options && typeof options == 'object')
        {
            ajaxOpts = jQuery.extend(true, ajaxOpts, options);
        }

        // Run Ajax Call
        if(async)
        {
            var timeout = 200;

            if(options && options.loadTimeout !== undefined && !isNaN(options.loadTimeout))
            {
                timeout = options.loadTimeout;
            }

            if(!this.timeout)
            {
                this.timeout = {};
            }
            else
            {
                clearTimeout(this.timeout[url]);
            }

            this.timeout[url] = setTimeout(function()
            {
                jQuery.ajax(ajaxOpts);
            }, timeout);
        }
        else
        {
            jQuery.ajax(ajaxOpts);
        }

        if(!async)
        {
            if(typeof onComplete == 'function' && response)
            {
                responseText    = this.IsJsonString(response.responseText) ? response.responseText : null;
                parsedJson      = jQuery.parseJSON(responseText);

                if(parsedJson && _.isObject(parsedJson) && parsedJson.responseType && parsedJson.errorClass && parsedJson.errorClass == 'TokenMismatchException')
                {
                    var msg = parsedJson.message && parsedJson.message !== '' ? parsedJson.message : 'Click ok to login'

                    swal({
                        type: 'error',
                        title: 'Your login session has expired',
                        text: msg,
                        buttons: true,
                        confirmButtonText: 'Refresh'
                    }).then(function()
                    {
                        window.loadUrl(window.location.href);
                    }).catch(swal.noop);

                    return true;
                }
                else
                {
                    onComplete(response, parsedJson);
                }
            }

            if(typeof response.responseText == 'undefined' || response.responseText == '' || !this.IsJsonString(response.responseText))
            {
                return false;
            }

            response = jQuery.parseJSON(response.responseText);

            if(typeof response == 'object')
            {
                return response
            }
            else
            {
                return false;
            }
        }

        return false;
    },

    /**
     * updateFlags
     *
     */
    updateFlag: function(listSection, id, element)
    {
        var currentElement  = jQuery(element);
        var flagIcon        = currentElement.find('span.flagItem');
        var flag            = flagIcon.data('flag');
        var flagValue       = 0;

        switch(flag) {
            case 'Important':
                flagIcon.data('flag', 'Review');
                flagIcon.switchClass(flag, 'Review');
                flagValue = 2;
                break;
            case 'Review':
                flagIcon.data('flag', 'None');
                flagIcon.switchClass(flag, 'None');
                flagValue = 0;
                break;
            case 'None':
                flagIcon.data('flag', 'Important');
                flagIcon.switchClass(flag, 'Important');
                flagValue = 1;
                break;
            default:
                flagIcon.data('flag', 'Important');
                flagIcon.switchClass(flag, 'Important');
                flagValue = 1;
                return false;
        }

        return this.updateFlagAjax(listSection, id, flagValue);

    },

    /**
     * Update Ajax Flag
     *
     */
    updateFlagAjax: function(listSection, id, flagValue) {

        // Set response variable
        var response;

        var url = '/' + listSection + '/updateFlag';

        var params = {
            "id" : id,
            'flagValue':flagValue
        };

        // Run Ajax Call
        jQuery.ajax({
            'async': false,
            'type': "GET",
            'global': false,
            'dataType': 'json',
            'data': params,
            'url': url,
            'success': function (data) {
                response = data;
            }
        });

        return response;
    },

    /**
     * Compare Arrays
     *
     */
    arrayEquals: function(a1, a2)
    {
        return JSON.stringify(a1)==JSON.stringify(a2);
    },

    /**
     * Expand Quick Edit Box
     *
     * @param id
     * @param boardIndex
     * @param options
     */
    expandDisplayQuickEdit: function(id, boardIndex, options)
    {
        var quickEditBox    = '#expand_' + id,
            editBox         = jQuery(quickEditBox),
            closeBtn        = document.querySelector('.close-quick[data-model-id="'+ id +'"]');

        this.collapseQuickEditBoxes(id);

        if(editBox.exists())
        {
            this.openedQuickEditBoxes.push(id);
            editBox.show();

            this.data.lastDisplayQuickEdit  = id;
            this.data.lastSchedulerBoard    = boardIndex;

            this.startSpinner(id);
            this.getSchedulerContents(id, editBox.find('.displayContents'), boardIndex, options);

            if(closeBtn)
            {
                closeBtn.classList.remove('hide');
            }

            setTimeout(function()
            {
                if(typeof Scheduler != 'undefined' || Scheduler.refreshScheduler != undefined)
                {
                    Scheduler.refreshScheduler();
                }
            }, 0);
        }

        this.stopSpinner(id);
    },

    /**
     * Open Quick Scheduler
     *
     * @param {int} id
     * @return {*}
     */
    openQuickScheduler: function(id)
    {
        var selectBox = document.querySelector('select.display-dropdown[data-model-id="'+ id +'"]');

        if(selectBox && selectBox.options.length)
        {
            var context         = this,
                currentValue    = selectBox.value,
                options         = selectBox.options,
                selectedIndex   = selectBox.selectedIndex,
                selectedOption  = options[selectedIndex];

            if(selectedOption)
            {
                context.data.schedulerBoardModal = new ModalBox({
                    modalClass          : 'modal-dialog modal-lg',
                    modalTitle          : 'Slideshow Scheduler',
                    modalTitleClass     : 'modal-title',
                    modalId             : 'scheduler-modal',
                    modalFooter         : {
                        show            : true,
                        close           : true,
                        closeText       : 'Close'
                    },
                    onHide: function(_this, event)
                    {
                        if(event.target === _this.dom.wrapper)
                        {
                            _this.destroy();
                            context.data.schedulerBoardModal = null;
                        }
                        else
                        {
                            _this.open();
                        }

                    },
                    onShow: function()
                    {
                        // jQuery(".scrollResult").perfectScrollbar();
                        
                    },
                    onShown: function()
                    {
                    }
                });

                context.data.schedulerBoardModal.setBodyContents(this.getSchedulerBodyContent(id));
                
                context.data.schedulerBoardModal.open();

                setTimeout(function()
                {
                    View.expandDisplayQuickEdit(id, currentValue);
                }, 100);
            }
        }
    },

    /**
     * Get SchedulerBodyContent
     * 
     * @param {*} id 
     * @returns {Object}
     */
    getSchedulerBodyContent: function(id)
    {
        return new DomUtils().createElementArray('div', {
            classList : "expandable displayExpandable",
            id        : 'expand_' + id,
            children  : [
                {
                    tag       : 'div',
                    id        : 'spinner-' + id
                },
                {
                    tag       : 'div',
                    classList : 'displayContents'
                }
            ]
        });
    },

    /**
     * Collapse Quick Edit Box
     *
     * @param id
     * @param currentId
     */
    collapseDisplayQuickEdit: function(id, currentId)
    {
        var quickEditBox    = '#expand_' + id,
            editBox         = jQuery(quickEditBox),
            closeBtn        = document.querySelector('.close-quick[data-model-id="'+ id +'"]');

        if(typeof currentId != 'undefined' && currentId  != id)
        {
            var index   = this.openedQuickEditBoxes.indexOf(id);
            this.openedQuickEditBoxes.splice(index, 1);

            this.stopSpinner(this.openedQuickEditBoxes[index]);
        }

        editBox.hide();
        editBox.find('.displayContents').html('');

        if(closeBtn)
        {
            closeBtn.classList.add('hide');
        }

        this.data.lastDisplayQuickEdit = 0;

        // Cancel page locking
        this.cancelPageLock();
    },

    /**
     * Collapse All Quick Edit Boxes
     *
     * @param id
     */
    collapseQuickEditBoxes: function(id)
    {
        if(this.openedQuickEditBoxes && this.openedQuickEditBoxes.length)
        {
            for(var i = 0; i < this.openedQuickEditBoxes.length; i++)
            {
                this.collapseDisplayQuickEdit(this.openedQuickEditBoxes[i], id);
            }
        }
    },

    /**
     * Start Spinner
     *
     * @param id
     */
    startSpinner: function(id)
    {
        var spinContainer = '#spinner-' + id;

        // Add spinner object using options from intialize method
        this.displaySpinner[id] = new Spinner(this.spinOpts).spin();

        // Set Container
        var container = jQuery(spinContainer);
        // Append spinner to spinner element
        container.append(this.displaySpinner[id].el);
    },

    /**
     * Stop Spinner
     *
     */
    stopSpinner: function(id)
    {
        if(typeof View.displaySpinner[id] != 'undefined')
        {
            View.displaySpinner[id].stop();
        }
    },

    /**
     * Get Scheduler Contents
     *
     * @param id
     * @param container
     * @param boardIndex
     * @param options
     * @param callback
     */
    getSchedulerContents: function(id, container, boardIndex, options, callback)
    {
        boardIndex = typeof boardIndex != 'undefined' ? boardIndex : 1;

        var context = this,
            params  = {
            id:         id,
            board:      boardIndex,
            isAdmin:    this.isAdmin,
            isAjax:     true,
            options:    options
        }, url;

        url = '/' + (this.isAdmin ? 'admin' : 'client') + '/signage/displays/ajax-get-scheduler';

        this.runRequest(url, 'GET', params, false, function(response, responseText)
        {
            if(responseText && responseText.error)
            {
                swal({
                    title: "Failed to get Scheduler",
                    text: "There was an error",
                    type: 'error',
                    timer: 3000
                }).catch(swal.noop);
            }

            if(responseText && responseText.html)
            {
                container.html(responseText.html);

                context.stopSpinner(id);

                if(typeof callback == 'function')
                {
                    callback(responseText);
                }
            }

            setTimeout(function()
            {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
        });

        // Trigger page lock to prevent user from going back
        this.triggerPageLock();
    },

    /**
     * Is JSON String
     *
     * @param data
     * @returns {boolean}
     * @constructor
     */
    IsJsonString: function(data)
    {
        try
        {
            JSON.parse(data);
        }
        catch(e)
        {
            return false;
        }

        return true;
    },

    /**
     * Get Form Elements
     *
     * @param formElement
     * @param forceFormData
     */
    getFormElements: function(formElement, forceFormData)
    {
        forceFormData = forceFormData === undefined ? false : forceFormData;

        if(formElement instanceof HTMLFormElement)
        {
            if(forceFormData)
            {
                return new FormData(formElement);
            }

            var parameters = {},
                elements   = formElement.elements;

            _.each(elements, function(elem)
            {
                if(elem.type === 'file')
                {
                    return new FormData(formElement);
                }

                parameters[elem.name] = jQuery(elem).val()
            });

            var formData = new FormData();

            for(var key in parameters)
            {
                if(parameters.hasOwnProperty(key))
                {
                    formData.append(key, parameters[key]);
                }
            }

            return formData;
        }

        return new FormData();
    },

    /**
     * Table Sorting
     *
     * @param key
     * @param direction
     */
    tableSorting: function(key, direction)
    {
        var target       = document.forms['filter-form'],
            element      = target.elements['sorting'];
            hideBackdrop = false;

        if(jQuery("#myModalfilter").length > 0 && (jQuery("#myModalfilter").data('bs.modal')) && (jQuery("#myModalfilter").data('bs.modal')).isShown)
        {
            hideBackdrop = true;
        }

        var properties = {
            dataKey: key,
            direction: direction
        };

        element.value = JSON.stringify(properties);

        var params  = this.getFormElements(target, false),
            method	= target.method ? target.method.toUpperCase() : 'POST';

        if(params instanceof FormData)
        {
            params.set('lajx', true);
        }
        else
        {
            params.lajx = true;
        }

        FTXCommon.Utils.showLoader();

        setTimeout(function()
        {
            View.runRequest(target.action, method, params, false, function(response, responseText)
            {
                if(hideBackdrop)
                {
                    jQuery('.modal-backdrop').get(0).remove();
                }

                window.parseFormResponse(responseText);
            });
        }, 300);

        this.cancelPageLock();
    },

    /**
     * Table Sorting Item Count
     *
     * @param relation
     * @param direction
     */
    tableSortingItemCount: function(relation, direction)
    {
        var form    = document.forms['filter-form'];
        var element = form.elements['sorting'];

        var properties = {
            relation:   relation,
            direction:  direction
        };

        element.value = JSON.stringify(properties);

        this.cancelPageLock();

        form.submit();
    },

    /**
     * Table Sorting With Filter
     *
     * @param relation
     * @param direction
     * @param key
     */
    tableSortingWithFilter: function(relation, direction, key)
    {
        var form    = document.forms['filter-form'];
        var element = form.elements['sorting'];

        var properties = {
            dataKey:    key,
            relation:   relation,
            direction:  direction
        };

        element.value = JSON.stringify(properties);

        this.cancelPageLock();

        form.submit();
    },

    /**
     * Check if Alpha Numberical
     *
     */
    alphanumeric: function(input)
    {
        var letterNumber = '^[a-zA-Z 0-9_.-]*$';

        return !!input.match(letterNumber);
    },

    /**
     * Capitalize
     *
     */
    capitalize: function(text)
    {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },

    /**
     * Filter Unique From Array
     *
     * @param a
     * @returns {*}
     */
    filterUnique: function(a)
    {
        var seen = {};
        return a.filter(function(item) {
            return seen.hasOwnProperty(item) ? false : (seen[item] = true);
        });
    },

    /**
     * Check if Resource Exists
     *
     */
    resourceExists: function(url)
    {
        var http = new XMLHttpRequest();

        http.open('HEAD', url, false);
        http.send();

        return http.status != 404;
    },

    /**
     * Check if string is JSON
     *
     * @param str
     * @returns {boolean}
     */
    isJSON: function(str)
    {
        try
        {
            JSON.parse(str);
        }
        catch(e)
        {
            return false;
        }

        return true;
    },

    /**
     * Load Google Font
     *
     * @param element
     * @param font
     */
    loadGoogleFont: function(element, font)
    {
        if(typeof element.exists != 'undefined' && element.exists())
        {
            font = font.replace(/\-/g,' ');

            WebFont.load({
                google: {
                    families: [font]
                }
            });

            jQuery(element).each(function()
            {
                if(jQuery(this).hasClass('nameBox') || jQuery(this).hasClass('gridPrice'))
                {
                    jQuery('#menuboard' + Display.getActiveBoardIndex()).find(jQuery(this)).css('font-family', font);
                }
                else
                {
                    jQuery(this).css('font-family', font);
                }
            });
        }
    },

    /**
     * Merge Objects
     *
     * @param object
     * @param toMerge
     * @returns {*}
     */
    mergeObjects: function(object, toMerge)
    {
        for(var key in toMerge)
        {
            if (toMerge.hasOwnProperty(key)) object[key] = toMerge[key];
        }

        return object;
    },

    /**
     * Add Back Lock
     */
    triggerPageLock: function()
    {
        window.onbeforeunload = function()
        {
            return "Leaving this page will cause any unsaved changes to be lost.";
        };
    },

    /**
     * Cancel Back Lock
     */
    cancelPageLock: function()
    {
        window.onbeforeunload = null;
    },

    /**
     * Handle Toggle Date
     *
     * @param {Optional|null|Boolean} initial
     */
    toggleDateTime: function(initial)
    {
        var initialRun          = initial || false,
            currentDateFormat   = Cookies.get('modelOutputDateType');

        if(initialRun)
        {
            if(currentDateFormat && currentDateFormat != '')
            {
                this.data.modelOutputTimeFormat = currentDateFormat;
            }
        }
        else
        {
            if(this.data.modelOutputTimeFormat == 'human-readable')
            {
                this.showNormalDateTime();
                this.data.modelOutputTimeFormat = 'date-time-date';
                Cookies.set('modelOutputDateType', 'date-time-date');
            }
            else
            {
                this.showHumanReadable();
                this.data.modelOutputTimeFormat = 'human-readable';
                Cookies.set('modelOutputDateType', 'human-readable');
            }
        }
    },

    /**
     * Show Normal Date Time
     *
     */
    showNormalDateTime: function()
    {
        jQuery('.date-time-date').removeClass('hide');
        jQuery('.human-readable').addClass('hide');
    },

    /**
     * Show Human Readable
     *
     */
    showHumanReadable: function()
    {
        jQuery('.human-readable').removeClass('hide');
        jQuery('.date-time-date').addClass('hide');
    },

    /**
     * Toggle Date Time
     *
     */
    toggleDateTimeOld: function()
    {
        var currentDateFormat = localStorage.getItem('dateType');

        consol.log(currentDateFormat);

        if(currentDateFormat == 'date-time-date')
        {
            jQuery('.date-time-date').addClass('hide');
            jQuery('.human-readable').removeClass('hide');
            localStorage.setItem('dateType', 'human-readable');
        }
        else if(currentDateFormat == 'human-readable')
        {
            jQuery('.human-readable').addClass('hide');
            jQuery('.date-time-date').removeClass('hide');
            localStorage.setItem('dateType', 'date-time-date');
        }
        //jQuery('.human-readable, .date-time-date').toggleClass('hide');
    }
};

/**
 * Check if selector Exists
 *
 */
(function($){
    $.fn.exists = function () {
        return this.length !== 0;
    }
})(jQuery);

/**
 * Swap Elements
 *
 */
(function($)
{
    $.fn.swap = function (elem) {
        elem = elem.jquery ? elem : $(elem);
        return this.each(function () {
            $(document.createTextNode('')).insertBefore(this).before(elem.before(this)).remove();
        });
    };
})(jQuery);

/**
 * Serialize Form into Object
 *
 */
(function($)
{
    $.fn.serializeObject = function()
    {

        var self            = this,
            json            = {},
            push_counters   = {},
            patterns        = {
                "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
                "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
                "push":     /^$/,
                "fixed":    /^\d+$/,
                "named":    /^[a-zA-Z0-9_]+$/
            };

        this.build = function(base, key, value)
        {
            base[key] = value;
            return base;
        };

        this.push_counter = function(key)
        {
            if(push_counters[key] === undefined)
            {
                push_counters[key] = 0;
            }

            return push_counters[key]++;
        };

        $.each($(this).serializeArray(), function()
        {
            // skip invalid keys
            if(!patterns.validate.test(this.name))
            {
                return;
            }

            var k,
                keys = this.name.match(patterns.key),
                merge = this.value,
                reverse_key = this.name;

            while((k = keys.pop()) !== undefined){

                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

                // push
                if(k.match(patterns.push)){
                    merge = self.build([], self.push_counter(reverse_key), merge);
                }

                // fixed
                else if(k.match(patterns.fixed)){
                    merge = self.build([], k, merge);
                }

                // named
                else if(k.match(patterns.named)){
                    merge = self.build({}, k, merge);
                }
            }

            json = $.extend(true, json, merge);
        });

        return json;
    };
})(jQuery);

/* * * * * * * * * * * * * * * * * *
 * Show/hide fields conditionally
 * * * * * * * * * * * * * * * * * */

(function($)
{
    $.fn.conditionize = function(options)
    {
        $.fn.showOrHideOrDisable = function(listenTo, listenFor, $section, type, original, replace)
        {
            var performAction   = false,
                listenEl        = $(listenTo),
                valueArray      = listenFor.toString().split('|'),
                checkedValue    = $(listenTo + ":checked").val(),
                checkedEmpty    = checkedValue === undefined && (_.contains(valueArray, '0') || _.contains(valueArray, '0') || _.contains(valueArray, 'undefined'));

            if(listenEl.is('select, input[type=text], input[type=hidden]') && _.contains(valueArray, listenEl.val()))
            {
                performAction = true;
            }
            else if(!listenEl.is('select, input[type=text]') && (_.contains(valueArray, checkedValue) || checkedEmpty))
            {
                performAction = true;
            }
            else
            {
                if(type === 'hide')
                {
                    $section.hide();
                }
                else if(type === 'disable')
                {
                    $section.attr('disabled', true);
                }
                else if(type === 'replace')
                {
                    $section.text(replace);
                }
                else if(type === 'show')
                {
                    $section.show();
                }
            }

            if(performAction)
            {
                if(type === 'hide')
                {
                    $section.show();
                }
                else if(type === 'disable')
                {
                    $section.removeAttr('disabled');

                    if($section.data('trigger-event'))
                    {
                        $selection.trigger($section.data('trigger-event'));
                    }
                }
                else if(type === 'replace')
                {
                    $section.text(original);
                }
                else if(type === 'show')
                {
                    $section.hide();
                }
            }
        };

        return this.each(function()
        {
            var listenTo    = "[name=" + $(this).data('cond-option') + "]",
                listenFor   = $(this).data('cond-value'),
                type        = $(this).data('cond-type') ? $(this).data('cond-type') : 'hide',
                original    = $(this).data('cond-original') ? $(this).data('cond-original') : 'Original N/A',
                replace     = $(this).data('cond-replace') ? $(this).data('cond-replace') : 'Replace N/A',
                $section    = $(this);

            if(listenTo !== undefined && listenTo !== '' && listenFor !== undefined && listenFor !== '')
            {
                // Set up event listener
                $(listenTo).on('change', function()
                {
                    $.fn.showOrHideOrDisable(listenTo, listenFor, $section, type, original, replace);
                });

                //Show based on current value on page load
                $.fn.showOrHideOrDisable(listenTo, listenFor, $section, type, original, replace);
            }
        });
    }
}(jQuery));

/**
 * Polyfill for Custom Event
 */
(function () {

    if ( typeof window.CustomEvent === "function" ) return false;

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail:  undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

/**
 * Polyfill for Object.assign
 */
(function () {
    if (typeof Object.assign !== 'function') {
        Object.assign = function(target) {
            'use strict';
            if (target == null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source != null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }
            return target;
        };
    }
})(Object.assign);

/**
 * Polyfill for Remove (node.remove())
 */
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if(this.parentNode)
                {
                    this.parentNode.removeChild(this);
                }
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/**
 * Applied Correctional Fix for Tooltip -> Bootstrap/Prototype Combination
 */
jQuery(window).load(function() {
    // Defer this code until after the window 'load' event finishes firing
    setTimeout(function() {
        window.HTMLElement &&
        window.HTMLElement.prototype.hide &&
        delete window.HTMLElement.prototype.hide;
    }, 0);
});

/**
 * Custom Serialization Function (HTMLElement)
 *
 * @param returnType
 * @returns {*}
 */
HTMLElement.prototype.serialize = function(returnType)
{
    var obj         = {},
        usedNames   = [],
        elements    = this.querySelectorAll('input, select, textarea');
        returnType  = returnType == undefined ? 'object' : (_.contains(['json', 'object', 'query'], returnType) ? returnType : 'object');

    for(var i = 0; i < elements.length; ++i)
    {
        var element = elements[i],
            name    = element.name,
            value   = element.value;

        if(_.contains(usedNames, name) || element.disabled)
        {
            continue;
        }

        if(element.nodeName == 'INPUT' && _.contains(['checkbox', 'radio'], element.type))
        {
            var checkboxElements = document.querySelectorAll('[name="'+name+'"]');

            if(checkboxElements.length)
            {
                var valArr = [];

                for(var c = 0; c < checkboxElements.length; c++)
                {
                    if(checkboxElements[c] && checkboxElements[c].checked === true)
                    {
                        valArr.push(checkboxElements[c].value);
                    }
                }

                if(valArr.length == 0)
                {
                    valArr = ['0']
                }

                if(_.isArray(valArr) && typeof valArr[0] !== 'undefined' && valArr.length == 1)
                {
                    if(valArr[0] == 1)
                    {
                        // noinspection JSValidateTypes
                        valArr = 1;
                    }
                    else if(valArr[0] == 0)
                    {
                        // noinspection JSValidateTypes
                        valArr = 0;
                    }
                    else if(typeof valArr[0] === 'string' && valArr[0] != '1' && valArr[0] != '0')
                    {
                        valArr = valArr[0];
                    }
                }

                obj[name] = valArr;
                usedNames.push(name);
                continue;
            }

            element = document.querySelector('[name="'+name+'"]:checked');
            value   = element && element.checked ? 1 : 0;

            obj[name] = value;
            usedNames.push(name);
            continue;
        }

        if(element.nodeName === 'SELECT' && element.multiple)
        {
            var selected = [];

            for(var s = 0; s < element.options.length; s++)
            {
                if(element.options[s].selected)
                {
                    selected.push(element.options[s].value);
                }
            }

            obj[name] = selected;
            usedNames.push(name);
            continue;
        }

        if(name)
        {
            obj[name] = value;
        }
    }

    if(returnType == 'object')
    {
        return obj;
    }
    else if(returnType == 'query')
    {
        var serializeQuery = function(obj)
        {
            var str = [];

            for(var p in obj)

                if(obj.hasOwnProperty(p))
                {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }

            return str.join("&");
        };

        return serializeQuery(obj);
    }
    else if(returnType == 'json')
    {
        return JSON.stringify(obj);
    }
    else
    {
        return obj;
    }
};

/**
 * Custom Populate Function
 *
 * @param formObj
 */
HTMLElement.prototype.populateForm = function(formObj)
{
    var elements = this.querySelectorAll('input, select, textarea');

    for(var i = 0; i < elements.length; ++i)
    {
        var element = elements[i],
            name    = element.name;

        if(element.disabled)
        {
            continue;
        }

        var formValue = formObj[name] != undefined ? formObj[name] : false;

        if(formValue != undefined || formValue != false)
        {
            if(element.nodeName == 'SELECT')
            {
                element.value = formValue;
            }
            else if(_.contains(['text', 'textarea', 'number'], element.type))
            {
                element.value = formValue;
            }
            else if(element.type == 'radio')
            {
                element.checked = element.value == formValue;
            }
            else if(element.type == 'checkbox')
            {
                //element.checked = Boolean(element.value == formValue);
                element.checked = Boolean(formValue);
            }

            FTXCommon.Utils.fireCustomEvent(element, 'change');
        }
    }
};

/**
 * Dispatch Event Polyfill
 */
!window.addEventListener && (function (WindowPrototype, DocumentPrototype, ElementPrototype, addEventListener, removeEventListener, dispatchEvent, registry) {
    WindowPrototype[addEventListener] = DocumentPrototype[addEventListener] = ElementPrototype[addEventListener] = function (type, listener) {
        var target = this;

        registry.unshift([target, type, listener, function (event) {
            event.currentTarget = target;
            event.preventDefault = function () { event.returnValue = false };
            event.stopPropagation = function () { event.cancelBubble = true };
            event.target = event.srcElement || target;

            listener.call(target, event);
        }]);

        this.attachEvent("on" + type, registry[0][3]);
    };

    WindowPrototype[removeEventListener] = DocumentPrototype[removeEventListener] = ElementPrototype[removeEventListener] = function (type, listener) {
        for (var index = 0, register; register = registry[index]; ++index) {
            if (register[0] == this && register[1] == type && register[2] == listener) {
                return this.detachEvent("on" + type, registry.splice(index, 1)[0][3]);
            }
        }
    };

    WindowPrototype[dispatchEvent] = DocumentPrototype[dispatchEvent] = ElementPrototype[dispatchEvent] = function (eventObject) {
        return this.fireEvent("on" + eventObject.type, eventObject);
    };
})(Window.prototype, HTMLDocument.prototype, Element.prototype, "addEventListener", "removeEventListener", "dispatchEvent", []);

navigator.sayswho = (function()
{
    var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if(/trident/i.test(M[1]))
    {
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }

    if(M[1]=== 'Chrome')
    {
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return M.join(' ');
})();

/**
 * Is Set
 *
 * Returns true if the variable at the path specified is not null and not undefined, otherwise returns false. The path is ignored if null or undefined.
 * Returns false otherwise
 *
 * @param {array|object} variable
 * @param {string} path
 * @returns {boolean}
 */
function isset(variable, path)
{
    if(path !== null && path !== undefined && variable !== null && variable !== undefined)
    {
        variable = try_get(variable, path);
    }

    return variable !== null && variable !== undefined;
}

/**
 * Is Defined
 *
 * Returns true if the variable at the path specified is not undefined, otherwise returns false. The path is ignored if null or undefined.
 * Returns false otherwise
 *
 * @param {array|object} variable
 * @param {string} path
 * @returns {boolean}
 */
function is_defined(variable, path)
{
    if(path !== null && path !== undefined)
    {
        variable = try_get(variable, path);
    }

    return variable !== undefined;
}

/**
 * Is Boolean
 *
 * Returns true if the variable given is a boolean, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_boolean(variable)
{
    return isset(variable) && typeof variable === 'boolean';
}

/**
 * Is Numeric
 *
 * Returns true if the variable given is a number, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_numeric(variable)
{
    return isset(variable) && !isNaN(variable);
}

/**
 * Is String
 *
 * Returns true if the variable given is a string, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_string(variable)
{
    return isset(variable) && typeof variable === 'string';
}

/**
 * Is Array
 *
 * Returns true if the variable given is an array, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_array(variable)
{
    return isset(variable) && (_.isArray(variable) || (!is_string(variable) && !isElement(variable) && !is_function(variable) && is_numeric(try_get(variable, 'length'))));
}

/**
 * Is Object
 *
 * Returns true if the variable given is an object, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_object(variable)
{
    return isset(variable) && typeof variable === 'object';
}

/**
 * Is Function
 *
 * Returns true if the variable given is a function, otherwise returns false.
 *
 * @param {*} variable
 * @returns {boolean}
 */
function is_function(variable)
{
    return isset(variable) && typeof variable === 'function';
}

/**
 * Defaulted
 *
 * Returns the val when isset(val) is true and extraConditionalCallback(val) is true, otherwise returns defaultVal. extraConditionalCallback is ignored when null or undefined.
 *
 * @param {*} val
 * @param {*} defaultVal
 * @param {function} extraConditionalCallback
 * @returns {*}
 */
function defaulted(val, defaultVal, extraConditionalCallback)
{
    extraConditionalCallback = is_function(extraConditionalCallback) ? extraConditionalCallback : function(val){return isset(val);};
    return extraConditionalCallback(val) ? val : defaultVal;
}


/**
 * Defaulted Strict
 *
 * Returns the val when is_defined(val) is true and extraConditionalCallback(val) is true, otherwise returns defaultVal. extraConditionalCallback is ignored when null or undefined.
 *
 * @param {*} val
 * @param {*} defaultVal
 * @param {function} extraConditionalCallback
 * @returns {*}
 */
function defaultedStrict(val, defaultVal, extraConditionalCallback)
{
    extraConditionalCallback = is_function(extraConditionalCallback) ? extraConditionalCallback : function(val){return is_defined(val);};
    return extraConditionalCallback(val) ? val : defaultVal;
}

/**
 * String Prototype Includes
 *
 * This is a polyfill for the Includes function in the prototype String for older browser support
 *
 * @type {boolean}
 */
String.prototype.includes = defaulted(String.prototype.includes, function(str)
{
    if(is_string(str))
    {
        return this.indexOf(str) !== -1;
    }

    return false;
});

/**
 * To String
 *
 * Attempts to cast whatever is passed to string. If successful passes str back as a string. Otherwise if def is a string, returns def. Otherwise returns null.
 *
 * @param {*} str
 * @param {string} def
 * @returns {string}
 */
function toString(str, def)
{
    def = defaulted(def, null);

    try
    {
        str = '' + str;
    } catch (e)
    {
        str = null;
    }

    return is_string(str) ? str : (is_string(def) ? def : null);
}

/**
 * To Boolean
 *
 * Attempts to cast whatever is passed to boolean. If successful passes str back as a boolean. Otherwise if def is a boolean, returns def. Otherwise returns null.
 *
 * @param {*} bool
 * @param {boolean} def
 * @returns {boolean}
 */
function toBoolean(bool, def)
{
    def = defaulted(def, null);

    switch(typeof bool)
    {
        case 'boolean':
            break;
        case 'string':
            bool = (bool === 'true' || bool === '1') ? true : ((bool === 'false' || bool === '0') ? false : null);
            break;
        case 'number':
            bool = (bool === 1) ? true : ((bool === 0) ? false : null);
            break;
        default:
            bool = null;
            break;
    }

    return is_boolean(bool) ? bool : (is_boolean(def) ? def : null);
}

/**
 *
 * Try Get
 *
 * Returns a result given a path in any nested structure using Dot Notation. If the result is not found or isset(result) is false, returns defaultResult.
 *
 * @param {object|array} variable
 * @param {string|array} pathToGet
 * @param {*} defaultResult
 * @param {function} extraConditionalCallback
 * @returns {*}
 */
function try_get(variable, pathToGet, defaultResult, extraConditionalCallback)
{
    pathToGet                = toString(pathToGet);
    defaultResult            = defaulted(defaultResult, null);
    extraConditionalCallback = defaulted(extraConditionalCallback, function(val){return isset(val);}, is_function);

    if(!isset(pathToGet))
    {
        return defaultResult;
    }

    if(!isset(defaultResult))
    {
        defaultResult = null;
    }

    var validVariable = isset(variable),
        containsDot   = false;

    if(is_string(pathToGet))
    {
        containsDot = pathToGet.indexOf('.') !== -1;
    }

    if(validVariable && is_string(pathToGet) && !containsDot)
    {
        return isset(variable[pathToGet]) && extraConditionalCallback(variable[pathToGet]) ? variable[pathToGet] : defaultResult;
    }
    else if(validVariable && isset(pathToGet))
    {
        if(is_string(pathToGet) && containsDot)
        {
            pathToGet = pathToGet.split('.');
        }

        if(is_array(pathToGet))
        {
            var result = variable;

            _.every(pathToGet, function(key)
            {
                if(is_string(key) && isset(result[key]))
                {
                    result = result[key];
                    return true;
                }

                result = defaultResult;
                return false;
            });
        }

        return extraConditionalCallback(result) ? result : defaultResult;
    }

    return defaultResult;
}

/**
 *
 * Try Set
 *
 * Attempts to set the value at the given path, returns true if successful, otherwise returns false
 *
 * @param variable
 * @param pathToSet
 * @param valueToSet
 * @returns {boolean}
 */
function try_set(variable, pathToSet, valueToSet)
{
    if((is_object(variable) || is_array(variable)) && is_string(pathToSet))
    {
        var lastDot   = pathToSet.lastIndexOf('.'),
            pathToGet = lastDot !== -1 ? pathToSet.substr(0, lastDot) : null;

        pathToSet = pathToSet.substr(try_get(pathToGet, 'length', -1) + 1);

        var pathResult = isset(pathToSet) ? try_get(variable, pathToGet) : variable;

        if(is_object(pathResult) || is_array(pathResult))
        {
            pathResult[pathToSet] = valueToSet;
            return true;
        }
    }

    return false;
}

/**
 * Try Call
 *
 * Attempts to call the function at the given path, returns the result of the function if it is successful and the result passes the extraConditionalCallback, otherwise returns the default result
 *
 * @param variable
 * @param pathToCall
 * @param args
 * @param defaultResult
 * @param extraConditionalCallback
 * @returns {*}
 */
function try_call(variable, pathToCall, args, defaultResult, extraConditionalCallback)
{
    args = defaulted(args, [], is_array);

    var result  = null;

    if((is_object(variable) || is_array(variable)) && is_string(pathToCall))
    {
        var lastDot    = pathToCall.lastIndexOf('.'),
            pathToGet  = lastDot !== -1 ? pathToCall.substr(0, lastDot) : '',
            pathResult = !empty(pathToGet) ? try_get(variable, pathToGet) : variable;

        pathToCall = pathToCall.substr(!empty(pathToGet) ? pathToGet.length + 1 : 0);

        if(is_object(pathResult) || is_array(pathResult))
        {
            if(is_function(try_get(pathResult, pathToCall)))
            {
                result = call_func(pathResult[pathToCall], args, pathResult);
            }
        }
    }

    return defaulted(result, defaultResult, extraConditionalCallback);
}

/**
 * Additional Functions for underscore
 */
if(typeof jQuery !== 'undefined')
{
    if(typeof _ !== 'undefined')
    {
        jQuery(document).ready(function()
        {
            _.mixin({
                /**
                 * Pluck Chain
                 *
                 * Used to pluck a series of values from a given nested path in the objects in the array.
                 *
                 * @param {array} list
                 * @param {string} pathToGet
                 * @returns {array}
                 */
                pluckChain: function(list, pathToGet)
                {
                    return _.map(list, function(item)
                    {
                        return try_get(item, pathToGet);
                    });
                },

                /**
                 * Group By Chain
                 *
                 * Groups the array using values from a given nested path in the objects in the array.
                 *
                 * @param {array} list
                 * @param {string} pathToGet
                 * @returns {array}
                 */
                groupByChain: function(list, pathToGet)
                {
                    return _.groupBy(list, function(item)
                    {
                        return try_get(item, pathToGet);
                    });
                },

                /**
                 * Sort By Chain
                 *
                 * Sorts the array using values from a given nested path in the objects in the array.
                 *
                 * @param {array} list
                 * @param {string} pathToGet
                 * @returns {array}
                 */
                sortByChain: function(list, pathToGet)
                {
                    return _.sortBy(list, function(item)
                    {
                        return try_get(item, pathToGet);
                    });
                },

                /**
                 * Map With Keys
                 *
                 * Maps a given array or object into an object, expects a return of [key, value] where key is the first index and value is the second.
                 *
                 * @param {array} list
                 * @param {function} callback
                 * @returns {array}
                 */
                mapWithKeys: function(list, callback)
                {
                    var obj = {};

                    _.each(list, function(val, key)
                    {
                        var keyVal = call_func(callback, [val, key]),
                            mKey   = try_get(keyVal, 0),
                            mVal   = try_get(keyVal, 1);

                        obj[mKey] = mVal;
                    });

                    return obj;
                },

                sum: function(list, callback)
                {
                    callback = defaulted(callback, function(sum, val)
                    {
                        return sum + val;
                    }, is_function);

                    return _.reduce(list, callback, 0);
                },

                getRandom: function(list, number)
                {
                    if(!isset(number))
                    {
                        number = 1;
                    }

                    if(is_numeric(number) && number > 0)
                    {
                        var result            = [],
                            count             = try_get(list, 'length', 0),
                            possibleLocations = _.keys(list);

                        for(var i = 0; i < Math.min(number, count); i++)
                        {
                            var locationCount   = try_get(possibleLocations, 'length', 0),
                                location        = randomInt(0, locationCount - 1);

                            if(isset(location))
                            {
                                var locationKey = _.pull(possibleLocations, location),
                                    value       = try_get(list, locationKey);

                                if(isset(value))
                                {
                                    result.push(value);
                                }
                            }
                        }
                    }

                    return result;
                },

                pull: function(list, index)
                {
                    if(isset(list, index))
                    {
                        return _.first(list.splice(index, 1));
                    }
                },

                fill: function(item, count, deepCopy)
                {
                    var result = [];

                    for(var i = 0; i < count; i++)
                    {
                        var newItem = deepCopy && (is_array(item) || is_object(item)) ? $.extend(true, is_array(item) ? [] : {}, item) : item;
                        result.push(newItem);
                    }

                    return result;
                }
            });

            if(!is_function(_.chunk))
            {
                _.mixin({
                    chunk: function(list, count)
                    {
                        var result = [];

                        for(var i = 0, j = 0; i < list.length; i++, j = Math.floor(i / count))
                        {
                            if(!is_array(result[j]))
                            {
                                result[j] = [];
                            }

                            result[j].push(list[i]);
                        }

                        return result;
                    }
                });
            }
        });
    }
}

/**
 * Underscore To Words
 *
 * Takes an underscore_separated_string and makes it into Formal Words.
 *
 * @param {string} string
 * @returns {string}
 */
function underscoreToWords(string)
{
    if(!is_string(string) || string.length <= 0)
    {
        return '';
    }

    var strings = string.split('_');

    strings = _.map(strings, function(string)
    {
        return string.charAt(0).toUpperCase() + string.slice(1);
    });

    return strings.join(' ');

}

/**
 * Underscore To Words
 *
 * Takes Formal Words and makes it into an underscore_separated_string.
 *
 * @param {string} string
 * @returns {string}
 */
function wordsToUnderscore(string)
{
    if(!is_string(string) || string.length <= 0)
    {
        return '';
    }

    var strings = string.split(' ');

    strings = _.map(strings, function(string)
    {
        return string.toLowerCase();
    });

    return strings.join('_');
}

/**
 * Camel To Words
 *
 * Takes camelCasedWords and makes it into Formal Words
 *
 * @param {string} string
 * @returns {string}
 */
function camelToWords(string)
{
    if(!is_string(string) || string.length <= 0)
    {
        return '';
    }

    var strings;

    strings = (strings = string.replace(/((?:^[a-z]+|[A-Z]+(?=[A-Z][a-z]))|(?:[0-9]+)|(?:[A-Z]+(?=[A-Z]|$))|(?:[A-Z][a-z]+))/g, '$1 ')).slice(0, strings.length - 1).split(/ /g);///(?=[A-Z])/);

    strings = _.map(strings, function(string)
    {
        return string.charAt(0).toUpperCase() + string.slice(1);
    });

    return strings.join(' ');

}

/**
 * Words To Camel
 *
 * Takes Formal Words and makes it into camelCasedWords
 *
 * @param {string} string
 * @returns {string}
 */
function wordsToCamel(string)
{
    if(!is_string(string) || string.length <= 0)
    {
        return '';
    }

    var strings = string.split(' '),
        first   = true;

    strings = _.map(strings, function(string)
    {
        if(first)
        {
            first = false;
            return string.toLowerCase();
        }

        return string.charAt(0).toUpperCase() + string.slice(1);
    });

    return strings.join('');
}

/**
 * Singular
 *
 * Takes A Plural and makes it a Singular
 */
function singular(word)
{
    if(word[word.length - 1] === 's')
    {
        word = word.substr(0, word.length - 1);
    }

    return word;
}

/**
 * Is Json String
 *
 * @param {string} data
 * @returns {boolean}
 * @constructor
 */
function IsJsonString(data)
{
    try
    {
        JSON.parse(data);
    }
    catch(e)
    {
        return false;
    }

    return true;
}

/**
 * Empty
 *
 * Returns false when notEmpty(variable, key) is true. Otherwise returns true.
 *
 * @param variable
 * @param key
 * @returns {boolean}
 */
function empty(variable, key)
{
    return !notEmpty(variable, key);
}

/**
 * Not Empty
 *
 * Returns true when
 *  - Objects:
 *  - Arrays:
 *  - Strings:
 *      Have contents in them (length of it is greater than 0)
 *  - default:
 *      isset(variable) is true
 *
 * @param variable
 * @param key
 * @returns {boolean}
 */
function notEmpty(variable, key)
{
    variable = isset(key) ? try_get(variable, key) : variable;
    return (is_string(variable) || is_array(variable) ? variable.length > 0 : (is_object(variable) ? objectValues(variable).length > 0 : isset(variable)));
}

/**
 * Coalesce
 *
 * Returns the first value to pass isset(val), otherwise returns null.
 *
 * @returns {*}
 */
function coalesce()
{
    var args = objectValues(arguments);

    for(var i = 0; i < args.length; i++)
    {
        if(isset(args, i))
        {
            return args[i];
        }
    }

    return null;
}

/**
 * Random Int
 *
 * Returns a random integer between the min and max inclusive
 *
 * @param {number} min
 * @param {number} max
 * @returns {*}
 */
function randomInt(min, max)
{
    if(is_numeric(min) && is_numeric(max) && min < max)
    {
        var rand  = Math.random(),
            range = (max - min) + 1;

        return Math.floor(rand * range) + min;
    }
    else if(min == max)
    {
        return min;
    }

    return null;
}

/**
 * Array Prototype Remove
 *
 * Removes the provided values from the array if found
 *
 * @returns {array}
 */
/*
Array.prototype.remove = function()
{
    var a = arguments,
        L = a.length,
        what,
        ax;

    while (L && this.length)
    {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1)
        {
            this.splice(ax, 1);
        }
    }
    return this;
};
*/

/**
 * Array Prototype Get Random
 *
 * Gets a random number of elements from the array and returns them
 *
 * @param {number} number
 * @returns {array}
 */
/*
Array.prototype.getRandom = function(number)
{
    if(!isset(number))
    {
        number = 1;
    }

    if(is_numeric(number) && number > 0)
    {
        var result            = [],
            count             = try_get(this, 'length', 0),
            possibleLocations = _.keys(this);

        for(var i = 0; i < Math.min(number, count); i++)
        {
            var locationCount   = try_get(possibleLocations, 'length', 0),
                location        = randomInt(0, locationCount - 1);

            if(isset(location))
            {
                var locationKey = possibleLocations.pull(location),
                    value       = try_get(this, locationKey);

                if(isset(value))
                {
                    result.push(value);
                }
            }
        }
    }

    return result;
};
*/

/**
 * Pull
 *
 * Returns the value at the given index, and removes it from the array shifting values below it
 *
 * @param {number} index
 * @returns {*}
 */
/*
Array.prototype.pull = function(index)
{
    if(isset(this, index))
    {
        return _.first(this.splice(index, 1));
    }
};
*/

/**
 * Html To Element
 *
 * Returns the parsed html as a DOMElement
 *
 * @param html
 * @returns {*}
 */
function htmlToElement(html)
{
    return _.first(htmlToElements(html));
}

/**
 * Html To Elements
 *
 * Returns the parsed html as a list DOMElements
 *
 * @param html
 * @returns {*}
 */
function htmlToElements(html)
{
    if(!is_string(html))
    {
        return null;
    }

    html = html.replace(/\s\s+/g, ' ');
    html = html.replace(/(?:\r\n|\r|\n)/g, '');

    var parser = document.createElement('div');

    parser.innerHTML = html;

    return parser instanceof HTMLElement ? _.map(parser.children) : [];
}

/**
 * Get Random Color
 *
 * Returns a random hex color
 *
 * @returns {string}
 */
function getRandomColor()
{
    var letters = '0123456789ABCDEF',
        color   = '#';

    for (var i = 0; i < 6; i++)
    {
        color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
}

/**
 * Find Closest
 *
 * Returns the closest DOMElement found near element that matches the selector
 *
 * @param {object} element
 * @param {string} selector
 * @param {number} maxDistance
 * @returns {*}
 */
function findClosest(element, selector, maxDistance)
{
    if(!isset(maxDistance))
    {
        maxDistance = 5;
    }

    var result      = null,
        parent      = try_get(element, 'parentNode'),
        distance    = 0;

    while(!isset(result) && isset(parent) && distance < maxDistance)
    {
        result = parent.querySelector(selector);
        parent = try_get(parent, 'parentNode');
        distance++;
    }

    return result;
}

if(isset(HTMLElement))
{
    /**
     * Append Html
     *
     * Used to append html to an existing HTMLElement
     *
     * @param {HTMLElement} element
     * @param {string} html
     */
    function appendHTML(element, html)
    {
        if(element instanceof HTMLElement)
        {
            element.innerHTML += html;
        }
    }

    /**
     * Append Element
     *
     * Used to append a single element to an existing HTMLElement, will convert from string to HTMLElement if needed
     *
     * @param {HTMLElement} element
     * @param {HTMLElement|string} newElement
     */
    function appendElement(element, newElement)
    {
        if(element instanceof HTMLElement)
        {
            if(is_string(newElement))
            {
                newElement = htmlToElement(newElement);
            }

            if(!(newElement instanceof HTMLElement))
            {
                return;
            }

            element.appendChild(newElement);
        }
    }

    /**
     * Append Elements
     *
     * Used to append multiple elements to an existing HTMLElement, will convert from string to HTMLElements if needed
     *
     * @param {HTMLElement} element
     * @param {array|string} newElements
     */
    function appendElements(element, newElements)
    {
        if(element instanceof HTMLElement)
        {
            if(is_string(newElements))
            {
                newElements = htmlToElements(newElements);
            }

            if(try_get(newElements, 'length'))
            {
                _.each(newElements, function(newElement)
                {
                    appendElement(element, newElement);
                });
            }
        }
    }

    /**
     * Prepend Element
     *
     * Used to prepend a single element to an existing HTMLElement, will convert from string to HTMLElement if needed
     *
     * @param {HTMLElement} element
     * @param {HTMLElement|string} newElement
     */
    function prependElement(element, newElement)
    {
        if(element instanceof HTMLElement)
        {
            if(is_string(newElement))
            {
                newElement = htmlToElement(newElement);
            }

            if(!(newElement instanceof HTMLElement))
            {
                return;
            }

            element.insertBefore(newElement, (element.hasChildNodes())
                ? element.childNodes[0]
                : null);
        }
    }

    /**
     * Prepend Elements
     *
     * Used to prepend multiple elements to an existing HTMLElement, will convert from string to HTMLElements if needed
     *
     * @param {HTMLElement} element
     * @param {array|string} newElements
     */
    function prependElements(element, newElements)
    {
        if(element instanceof HTMLElement)
        {
            if(is_string(newElements))
            {
                newElements = htmlToElements(newElements);
            }

            if(newElements.length !== undefined && !isNaN(newElements.length) && newElements.shift !== undefined)
            {
                _.each(newElements.reverse(), function(curElement)
                {
                    prependElement(element, curElement);
                });
            }
        }
    }

    /**
     * Remove Element
     *
     * Used to remove an element from the document
     *
     * @param element
     */
    function removeElement(element)
    {
        if(element instanceof HTMLElement && element.parentNode instanceof HTMLElement)
        {
            element.parentNode.removeChild(element);
        }
    }
}

/**
 * String Replace All
 *
 * Replaces each found occurance with the replacement string
 *
 * @param {string} string
 * @param {string} find
 * @param {string} replace
 * @return {string}
 */
function stringReplaceAll(string, find, replace)
{
    if(is_object(find))
    {
        _.each(find, function(r, f)
        {
            string = stringReplaceAll(string, f, r);
        });

        return string;
    }

    if(!is_array(find))
    {
        find = [find];
    }

    if(is_string(string) && !empty(string) && is_array(find) && !empty(find))
    {
        _.each(find, function(findIter)
        {
            var findIndex = 0;

            if(is_string(findIter) && !empty(findIter))
            {
                while((findIndex = string.indexOf(findIter, findIndex)) !== -1)
                {
                    string = string.replace(findIter, replace);

                    if(replace.length > findIter.length)
                    {
                        findIter += (replace.length - findIter.length);
                    }
                }
            }
        });
    }

    // var regex = new RegExp('/' + string + '/g');

    return string;//.replace(regex);
}

/**
 * Is Element
 *
 * Returns true if the passed object is an HTMLElement
 *
 * @param {object} obj
 * @returns {boolean}
 */
function isElement(obj)
{
    try
    {
        //Using W3 DOM2 (works for FF, Opera and Chrome)
        return obj instanceof HTMLElement;
    }
    catch(e)
    {
        //Browsers not supporting W3 DOM2 don't have HTMLElement and
        //an exception is thrown and we end up here. Testing some
        //properties that all elements have (works on IE7)
        return (typeof obj==="object") &&
            (obj.nodeType===1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument ==="object");
    }
}

/**
 * Object Values
 *
 * Returns the values contained in an object as an array
 *
 * @param obj
 * @returns {Array}
 */
function objectValues(obj)
{
    if(is_function(try_get(Object, 'values')))
    {
        return Object.values(obj);
    }

    var res = [];

    for(var i in obj)
    {
        if(obj.hasOwnProperty(i))
        {
            res.push(obj[i]);
        }
    }

    return res;
}


/**
 * Call Function
 *
 * Calls the function with the array as a list of arguments, returns the result of the function
 *
 * @param {Function} func
 * @param {Array} args
 * @param {Object|null} scope
 * @returns {*}
 */
function call_func(func, args, scope)
{
    var defArgs = isset(args) ? [args] : [];
    args  = defaulted(args, defArgs, is_array);
    scope = defaulted(scope, null, is_object);

    if(is_function(func))
    {
        return func.apply(scope, args);
    }

    return null;
}

/**
 * Every Function
 *
 * Returns a function that when called, returns true if all of the functions called with the arguments passed returns true
 *
 * @returns {function(): boolean}
 */
function every_func()
{
    var valid = true,
        funcs = objectValues(arguments);

    return function()
    {
        var args = objectValues(arguments);

        for(var i = 0; valid && i < funcs.length; i++)
        {
            var func = funcs[i];
            if(is_function(func))
            {
                valid &= call_func(func, args);
            }
        }

        return valid;
    }
}

/**
 * Any Function
 *
 * Returns a function that when called, returns true if any of the functions called with the arguments passed returns true
 *
 * @returns {function(): boolean}
 */
function any_func()
{
    var valid = false,
        funcs = objectValues(arguments);

    return function()
    {
        var args = objectValues(arguments);

        for(var i = 0; !valid && i < funcs.length; i++)
        {
            var func = funcs[i];
            if(is_function(func))
            {
                valid |= call_func(func, args);
            }
        }

        return valid;
    }
}

/**
 * Is HTML
 *
 * Returns true if the string contains a valid HTML Element, otherwise returns false
 *
 * @param {string} html
 * @returns {boolean}
 */
function is_html(html)
{
    var elements = htmlToElements(html);

    return elements.length > 0;
}

/**
 * Get Url Params
 *
 * Returns the parameters of a given url
 *
 * @param url
 * @returns {*}
 */
function getUrlParams(url)
{
    var questionIndex = is_string(url) ? url.indexOf('?') : -1;

    if(questionIndex !== -1)
    {
        var params = url.slice(questionIndex + 1);
        return _.mapWithKeys(params.split('&'), function(param)
        {
            var params = param.split('='),
                key    = try_get(params, 0),
                val    = try_get(params, 1);

            return [key, val];
        });
    }

    return null;
}

/**
 * Implode Url Params
 *
 * Returns the parameters of a given url
 *
 * @param params
 * @returns {*}
 */
function implodeUrlParams(params)
{
    var res  = [],
        keys = Object.keys(params);

    for(var i = 0; i < keys.length; i++)
    {
        var key = keys[i];

        res.push(key + '=' + params[key]);
    }

    return res.join('&');
}

/**
 * Get Url Without Query
 *
 * @returns {string}
 */
function getUrlWithoutQuery()
{
    return [location.protocol, '//', location.host, location.pathname].join('');
}

function getTrendLineStartingEndingPoints(xArray, yArray)
{
    var regressionLine = function(x, y)
        {
            var n     = _.size(x),  // number of items in the array
                sumX  = _.sum(x),   // sum of all X values
                sumY  = _.sum(y),   // sum of all Y values
                sumXX = 0,
                sumXY = 0;

            for(var i = 0; i < n; i++)
            {
                sumXY += x[i] * y[i];
                sumXX += x[i] * x[i];
            }

            var rightSide = (n * sumXX) - (sumX * sumX),
                slope     = rightSide > 0 ? (((n * sumXY) - (sumX * sumY)) / rightSide) : 0,
                intercept = (sumY - (slope * sumX)) / n;

            return {
                slope     : slope,
                intercept : intercept,
            }
        },
        regressionInfo  = regressionLine(xArray, yArray),
        firstX          = _.first(xArray),
        lastX           = _.last(xArray),
        firstVal        = (firstX * regressionInfo.slope) + regressionInfo.intercept,
        lastVal         = (lastX  * regressionInfo.slope) + regressionInfo.intercept;

    return [Math.round(firstVal), Math.round(lastVal)];
}

function lerp(from, amt, to)
{
    return (1 - amt) * from + (amt * to);
}

function blade(v)
{
    return v;
}

function pullProperty(obj, prop)
{
    if(!is_object(obj))
    {
        return undefined;
    }

    var res = obj[prop];

    if(res !== undefined)
    {
        delete obj[prop];
    }

    return res;
}

function encodeHtmlSpecialChars(text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

function decodeHtmlSpecialChars(text) {
    var map = {
        '&amp;': '&',
        '&#038;': "&",
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'",
        '&#8217;': "’",
        '&#8216;': "‘",
        '&#8211;': "–",
        '&#8212;': "—",
        '&#8230;': "…",
        '&#8221;': '”'
    };

    return text.replace(/\&[\w\d\#]{2,5}\;/g, function(m) { return map[m]; });
}

function isValidJSON(text)
{
    if(is_string(text) && /^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
    replace(/(?:^|:|,)(?:\s*\[)+/g, '')))
    {
        return true;
    }

    return false;
}

/**
 * Get Unix Time
 *
 * Returns the current unix time in seconds
 *
 * @returns {number}
 */
function getUnixTime()
{
    var date = new Date();

    return date.getTime() / 1000 | 0;
}

function triggerDebugger()
{
    debugger;
}

/**
 * Tooltip List
 * Creates a tooltip for the element given a list of values or objects
 *
 * @param {Element} element
 * @param {Array} list
 * @returns {Element}
 */
function tooltipList(element, list)
{
    if(!empty(list) && is_array(list))
    {
        var first = _.first(list);

        if(is_object(first))
        {
            list = _.map(list, function(item)
            {
                return objectValues(item).join(' - ');
            });
        }

        element.title = list.join('<br>');

        $(element).tooltip({
            html      : true,
            container : 'body',
            placement : 'right',
            trigger   : 'hover'
        });
    }

    return element;
}

/**
 * Popup Table
 * Onclick will open a modal containing the items in a table
 *
 * @param {Element} element
 * @param {Array} items
 * @param {string} title
 * @param {Array|null} columns
 * @param {Array|null} extraButtons
 * @returns {Element}
 */
function popupTable(element, items, title, columns, extraButtons)
{
    title = defaulted(title, element.innerText);

    if(!empty(items) && is_array(items))
    {
        var first = _.first(items);

        if(!is_object(first))
        {
            items = _.map(items, function(item)
            {
                var obj = {};

                obj[wordsToUnderscore(title)] = item;

                return obj;
            });

            first = _.first(items);
        }

        if(!is_array(columns))
        {
            columns = _.map(first, function(value, key)
            {
                return {
                    key    : key,
                    header : underscoreToWords(key),
                };
            });
        }

        element.style.cursor         = 'pointer';
        element.style.color          = 'blue';
        element.style.textDecoration = 'underline';
        element.onclick              = function()
        {
            var modalBox = new ModalBox({
                modalClass          : 'modal-dialog',
                modalTitle          : title,
                modalTitleClass     : 'modal-title',
                modalFooter     : {
                    show        : true,
                    close       : true,
                    closeText   : 'Close',
                    buttons     : extraButtons ? extraButtons : ''
                },
            });

            modalBox.setBodyContents((new DomUtils()).createTable(columns, items, {
                classList: [
                    'table-bordered',
                    'table-striped',
                    'table-condensed',
                    'w100p',
                ],
            }, {
                withoutHeader: _.size(columns) <= 1
            }));

            modalBox.open();
        };
    }

    return element;
}


/**
 * Make Url from params and append to original url
 *
 * @param {String} url
 * @param {Object} params
 * @return {string}
 */
function makeUrlFromParams(url, params)
{
    var out = [];

    for(var key in params)
    {
        if(params.hasOwnProperty(key))
        {
            out.push(key + '=' + encodeURIComponent(params[key]));
        }
    }

    return url + (url.search(/\?/g) !== -1 ? '&' : '?') + out.join('&');
}

function fixDataTableSearch()
{
    $('div.dataTables_filter input').off('keyup.DT input.DT');

    var searchDelay = null;

    $('div.dataTables_filter input').on('keyup', function() {
        var search       = $('div.dataTables_filter input').val(),
            tableWrapper = $(this).closest('.dataTables_wrapper'),
            table        = tableWrapper.find('table'),
            dataTable    = table.DataTable(),
            timeout      = try_get(dataTable.settings()[0], 'searchDelay', 2000);

        clearTimeout(searchDelay);

        searchDelay = setTimeout(function()
        {
            if(search != null)
            {
                dataTable.search(search).draw();
            }
        }, timeout);
    });
}

function XAND(a, b)
{
    return !(a || b) || (a && b);
}

function addHotkeyHandler()
{
    $(function()
    {
        var hotkeyElements = document.querySelectorAll('[data-hotkey]');

        for(var i = 0, hotkeyElement; (hotkeyElement = hotkeyElements[i]) && isElement(hotkeyElement); i++)
        {
            var data = (function()
                {
                    var data = hotkeyElement.dataset.hotkey.toLowerCase();

                    try
                    {
                        data = JSON.parse(data);
                    }
                    catch(e){}

                    if(is_string(data))
                    {
                        data = [data];
                    }

                    return data;
                })(),
                signature = data[0],
                action    = data[1] || 'click';

            if(is_function(hotkeyElement[action]))
            {
                keyboardJS.bind(signature, (function(hotkeyElement, action, e)
                {
                    hotkeyElement[action]();
                    e.preventDefault();
                    e.stopPropagation();
                }).bind(null, hotkeyElement, action));
            }
        }

        bindSaveHotkey();
    });
}

function bindSaveHotkey()
{
    var saveButton = document.querySelector('[data-save]');

    if(saveButton)
    {
        keyboardJS.bind('ctrl > s', function(e)
        {
            saveButton.click();
            e.preventDefault();
            e.stopPropagation();
        });
    }
}

/**
 * Polyfill for Element matches
 */
(function()
{
    if (!Element.prototype.matches)
    {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
})();

/** @license
 * eventsource.js
 * Available under MIT License (MIT)
 * https://github.com/Yaffle/EventSource/
 */
!function(a){"use strict";function b(){this.bitsNeeded=0,this.codePoint=0}function c(a){this.withCredentials=!1,this.responseType="",this.readyState=0,this.status=0,this.statusText="",this.responseText="",this.onprogress=E,this.onreadystatechange=E,this._contentType="",this._xhr=a,this._sendTimeout=0,this._abort=E}function d(a){return a.replace(/[A-Z]/g,function(a){return String.fromCharCode(a.charCodeAt(0)+32)})}function e(a){for(var b=Object.create(null),c=a.split("\r\n"),e=0;e<c.length;e+=1){var f=c[e],g=f.split(": "),h=g.shift(),i=g.join(": ");b[d(h)]=i}this._map=b}function f(){}function g(a){this._headers=a}function h(){}function i(){this._listeners=Object.create(null)}function j(a){q(function(){throw a},0)}function k(a){this.type=a,this.target=void 0}function l(a,b){k.call(this,a),this.data=b.data,this.lastEventId=b.lastEventId}function m(a,b){k.call(this,a),this.status=b.status,this.statusText=b.statusText,this.headers=b.headers}function n(a,b){i.call(this),this.onopen=void 0,this.onmessage=void 0,this.onerror=void 0,this.url=void 0,this.readyState=void 0,this.withCredentials=void 0,this._close=void 0,p(this,a,b)}function o(){return void 0!=s&&"withCredentials"in s.prototype||void 0==t?s:t}function p(a,b,d){b=String(b);var e=void 0!=d&&Boolean(d.withCredentials),g=S(1e3),i=void 0!=d&&void 0!=d.heartbeatTimeout?R(d.heartbeatTimeout,45e3):S(45e3),n="",p=g,s=!1,t=void 0!=d&&void 0!=d.headers?JSON.parse(JSON.stringify(d.headers)):void 0,u=void 0!=d&&void 0!=d.Transport?d.Transport:o(),v=!U||void 0!=d&&void 0!=d.Transport?new c(new u):void 0,w=void 0==v?new h:new f,x=void 0,y=0,z=F,A="",B="",C="",D="",E=K,P=0,Q=0,V=function(b,c,d,e,f){if(z===G)if(x=f,200===b&&void 0!=d&&O.test(d)){z=H,s=!0,p=g,a.readyState=H;var h=new m("open",{status:b,statusText:c,headers:e});a.dispatchEvent(h),T(a,a.onopen,h)}else{var i="";200!==b?(c&&(c=c.replace(/\s+/g," ")),i="EventSource's response has a status "+b+" "+c+" that is not 200. Aborting the connection."):i="EventSource's response has a Content-Type specifying an unsupported type: "+(void 0==d?"-":d.replace(/\s+/g," "))+". Aborting the connection.",j(new Error(i)),Y();var h=new m("error",{status:b,statusText:c,headers:e});a.dispatchEvent(h),T(a,a.onerror,h)}},W=function(b){if(z===H){for(var c=-1,d=0;d<b.length;d+=1){var e=b.charCodeAt(d);(e==="\n".charCodeAt(0)||e==="\r".charCodeAt(0))&&(c=d)}var f=(-1!==c?D:"")+b.slice(0,c+1);D=(-1===c?D:"")+b.slice(c+1),""!==f&&(s=!0);for(var h=0;h<f.length;h+=1){var e=f.charCodeAt(h);if(E===J&&e==="\n".charCodeAt(0))E=K;else if(E===J&&(E=K),e==="\r".charCodeAt(0)||e==="\n".charCodeAt(0)){if(E!==K){E===L&&(Q=h+1);var j=f.slice(P,Q-1),k=f.slice(Q+(h>Q&&f.charCodeAt(Q)===" ".charCodeAt(0)?1:0),h);"data"===j?(A+="\n",A+=k):"id"===j?B=k:"event"===j?C=k:"retry"===j?(g=R(k,g),p=g):"heartbeatTimeout"===j&&(i=R(k,i),0!==y&&(r(y),y=q(function(){Z()},i)))}if(E===K){if(""!==A){n=B,""===C&&(C="message");var m=new l(C,{data:A.slice(1),lastEventId:B});if(a.dispatchEvent(m),"message"===C&&T(a,a.onmessage,m),z===I)return}A="",C=""}E=e==="\r".charCodeAt(0)?J:K}else E===K&&(P=h,E=L),E===L?e===":".charCodeAt(0)&&(Q=h+1,E=M):E===M&&(E=N)}}},X=function(){if(z===H||z===G){z=F,0!==y&&(r(y),y=0),y=q(function(){Z()},p),p=S(Math.min(16*g,2*p)),a.readyState=G;var b=new k("error");a.dispatchEvent(b),T(a,a.onerror,b)}},Y=function(){z=I,void 0!=x&&(x(),x=void 0),0!==y&&(r(y),y=0),a.readyState=I},Z=function(){if(y=0,z!==F)return void(s||void 0==x?(s=!1,y=q(function(){Z()},i)):(j(new Error("No activity within "+i+" milliseconds. Reconnecting.")),x(),x=void 0));s=!1,y=q(function(){Z()},i),z=G,A="",C="",B=n,D="",P=0,Q=0,E=K;var a=b;"data:"!==b.slice(0,5)&&"blob:"!==b.slice(0,5)&&""!==n&&(a+=(-1===b.indexOf("?")?"?":"&")+"lastEventId="+encodeURIComponent(n));var c={};if(c.Accept="text/event-stream",void 0!=t)for(var d in t)Object.prototype.hasOwnProperty.call(t,d)&&(c[d]=t[d]);try{w.open(v,V,W,X,a,e,c)}catch(f){throw Y(),f}};a.url=b,a.readyState=G,a.withCredentials=e,a._close=Y,Z()}var q=a.setTimeout,r=a.clearTimeout,s=a.XMLHttpRequest,t=a.XDomainRequest,u=a.EventSource,v=a.document,w=a.Promise,x=a.fetch,y=a.Response,z=a.TextDecoder,A=a.TextEncoder,B=a.AbortController;if(void 0==Object.create&&(Object.create=function(a){function b(){}return b.prototype=a,new b}),void 0!=w&&void 0==w.prototype["finally"]&&(w.prototype["finally"]=function(a){return this.then(function(b){return w.resolve(a()).then(function(){return b})},function(b){return w.resolve(a()).then(function(){throw b})})}),void 0!=x){var C=x;x=function(a,b){return w.resolve(C(a,b))}}void 0==B&&(B=function(){this.signal=null,this.abort=function(){}}),b.prototype.decode=function(a){function b(a,b,c){if(1===c)return a>=128>>b&&2047>=a<<b;if(2===c)return a>=2048>>b&&55295>=a<<b||a>=57344>>b&&65535>=a<<b;if(3===c)return a>=65536>>b&&1114111>=a<<b;throw new Error}function c(a,b){if(6===a)return b>>6>15?3:b>31?2:1;if(12===a)return b>15?3:2;if(18===a)return 3;throw new Error}for(var d=65533,e="",f=this.bitsNeeded,g=this.codePoint,h=0;h<a.length;h+=1){var i=a[h];0!==f&&(128>i||i>191||!b(g<<6|63&i,f-6,c(f,g)))&&(f=0,g=d,e+=String.fromCharCode(g)),0===f?(i>=0&&127>=i?(f=0,g=i):i>=192&&223>=i?(f=6,g=31&i):i>=224&&239>=i?(f=12,g=15&i):i>=240&&247>=i?(f=18,g=7&i):(f=0,g=d),0===f||b(g,f,c(f,g))||(f=0,g=d)):(f-=6,g=g<<6|63&i),0===f&&(65535>=g?e+=String.fromCharCode(g):(e+=String.fromCharCode(55296+(g-65535-1>>10)),e+=String.fromCharCode(56320+(g-65535-1&1023))))}return this.bitsNeeded=f,this.codePoint=g,e};var D=function(){try{return"test"===(new z).decode((new A).encode("test"),{stream:!0})}catch(a){}return!1};void 0!=z&&void 0!=A&&D()||(z=b);var E=function(){};c.prototype.open=function(a,b){this._abort(!0);var c=this,d=this._xhr,e=1,f=0;this._abort=function(a){0!==c._sendTimeout&&(r(c._sendTimeout),c._sendTimeout=0),(1===e||2===e||3===e)&&(e=4,d.onload=E,d.onerror=E,d.onabort=E,d.onprogress=E,d.onreadystatechange=E,d.abort(),0!==f&&(r(f),f=0),a||(c.readyState=4,c.onreadystatechange())),e=0};var g=function(){if(1===e){var a=0,b="",f=void 0;if("contentType"in d)a=200,b="OK",f=d.contentType;else try{a=d.status,b=d.statusText,f=d.getResponseHeader("Content-Type")}catch(g){a=0,b="",f=void 0}0!==a&&(e=2,c.readyState=2,c.status=a,c.statusText=b,c._contentType=f,c.onreadystatechange())}},h=function(){if(g(),2===e||3===e){e=3;var a="";try{a=d.responseText}catch(b){}c.readyState=3,c.responseText=a,c.onprogress()}},i=function(){h(),(1===e||2===e||3===e)&&(e=4,0!==f&&(r(f),f=0),c.readyState=4,c.onreadystatechange())},j=function(){void 0!=d&&(4===d.readyState?i():3===d.readyState?h():2===d.readyState&&g())},k=function(){f=q(function(){k()},500),3===d.readyState&&h()};d.onload=i,d.onerror=i,d.onabort=i,"sendAsBinary"in s.prototype||"mozAnon"in s.prototype||(d.onprogress=h),d.onreadystatechange=j,"contentType"in d&&(b+=(-1===b.indexOf("?")?"?":"&")+"padding=true"),d.open(a,b,!0),"readyState"in d&&(f=q(function(){k()},0))},c.prototype.abort=function(){this._abort(!1)},c.prototype.getResponseHeader=function(a){return this._contentType},c.prototype.setRequestHeader=function(a,b){var c=this._xhr;"setRequestHeader"in c&&c.setRequestHeader(a,b)},c.prototype.getAllResponseHeaders=function(){return void 0!=this._xhr.getAllResponseHeaders?this._xhr.getAllResponseHeaders():""},c.prototype.send=function(){if(!("ontimeout"in s.prototype)&&void 0!=v&&void 0!=v.readyState&&"complete"!==v.readyState){var a=this;return void(a._sendTimeout=q(function(){a._sendTimeout=0,a.send()},4))}var b=this._xhr;b.withCredentials=this.withCredentials,b.responseType=this.responseType;try{b.send(void 0)}catch(c){throw c}},e.prototype.get=function(a){return this._map[d(a)]},f.prototype.open=function(a,b,c,d,f,g,h){a.open("GET",f);var i=0;a.onprogress=function(){var b=a.responseText,d=b.slice(i);i+=d.length,c(d)},a.onreadystatechange=function(){if(2===a.readyState){var c=a.status,f=a.statusText,g=a.getResponseHeader("Content-Type"),h=a.getAllResponseHeaders();b(c,f,g,new e(h),function(){a.abort()})}else 4===a.readyState&&d()},a.withCredentials=g,a.responseType="text";for(var j in h)Object.prototype.hasOwnProperty.call(h,j)&&a.setRequestHeader(j,h[j]);a.send()},g.prototype.get=function(a){return this._headers.get(a)},h.prototype.open=function(a,b,c,d,e,f,h){var i=new B,j=i.signal,k=new z;x(e,{headers:h,credentials:f?"include":"same-origin",signal:j,cache:"no-store"}).then(function(a){var d=a.body.getReader();return b(a.status,a.statusText,a.headers.get("Content-Type"),new g(a.headers),function(){i.abort(),d.cancel()}),new w(function(a,b){var e=function(){d.read().then(function(b){if(b.done)a(void 0);else{var d=k.decode(b.value,{stream:!0});c(d),e()}})["catch"](function(a){b(a)})};e()})})["finally"](function(){d()})},i.prototype.dispatchEvent=function(a){a.target=this;var b=this._listeners[a.type];if(void 0!=b)for(var c=b.length,d=0;c>d;d+=1){var e=b[d];try{"function"==typeof e.handleEvent?e.handleEvent(a):e.call(this,a)}catch(f){j(f)}}},i.prototype.addEventListener=function(a,b){a=String(a);var c=this._listeners,d=c[a];void 0==d&&(d=[],c[a]=d);for(var e=!1,f=0;f<d.length;f+=1)d[f]===b&&(e=!0);e||d.push(b)},i.prototype.removeEventListener=function(a,b){a=String(a);var c=this._listeners,d=c[a];if(void 0!=d){for(var e=[],f=0;f<d.length;f+=1)d[f]!==b&&e.push(d[f]);0===e.length?delete c[a]:c[a]=e}},l.prototype=Object.create(k.prototype),m.prototype=Object.create(k.prototype);var F=-1,G=0,H=1,I=2,J=-1,K=0,L=1,M=2,N=3,O=/^text\/event\-stream;?(\s*charset\=utf\-8)?$/i,P=1e3,Q=18e6,R=function(a,b){var c=parseInt(a,10);return c!==c&&(c=b),S(c)},S=function(a){return Math.min(Math.max(a,P),Q)},T=function(a,b,c){try{"function"==typeof b&&b.call(a,c)}catch(d){j(d)}},U=void 0!=x&&void 0!=y&&"body"in y.prototype;n.prototype=Object.create(i.prototype),n.prototype.CONNECTING=G,n.prototype.OPEN=H,n.prototype.CLOSED=I,n.prototype.close=function(){this._close()},n.CONNECTING=G,n.OPEN=H,n.CLOSED=I,n.prototype.withCredentials=void 0,function(b){if("object"==typeof module&&"object"==typeof module.exports){var c=b(exports);void 0!==c&&(module.exports=c)}else"function"==typeof define&&define.amd?define(["exports"],b):b(a)}(function(a){a.EventSourcePolyfill=n,a.NativeEventSource=u,void 0==s||void 0!=u&&"withCredentials"in u.prototype||(a.EventSource=n)})}("undefined"!=typeof window?window:this);

if (!("classList" in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function() {
            var self = this;
            function update(fn) {
                return function(value) {
                    var classes = self.className.split(/\s+/),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                }
            }

            var ret = {
                add: update(function(classes, index, value) {
                    ~index || classes.push(value);
                }),

                remove: update(function(classes, index) {
                    ~index && classes.splice(index, 1);
                }),

                toggle: update(function(classes, index, value) {
                    ~index ? classes.splice(index, 1) : classes.push(value);
                }),

                contains: function(value) {
                    return !!~self.className.split(/\s+/).indexOf(value);
                },

                item: function(i) {
                    return self.className.split(/\s+/)[i] || null;
                }
            };

            Object.defineProperty(ret, 'length', {
                get: function() {
                    return self.className.split(/\s+/).length;
                }
            });

            return ret;
        }
    });
}

/**
 * Polyfill for fill
 */
if(!Array.prototype.fill)
{
    Object.defineProperty(Array.prototype, 'fill', {
        value: function(value)
        {
            // Steps 1-2.
            if(this == null)
            {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);

            // Steps 3-5.
            var len = O.length >>> 0;

            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;

            // Step 8.
            var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ?

            len : end >> 0;

            // Step 11.
            var final = relativeEnd < 0 ?

            Math.max(len + relativeEnd, 0) :
            Math.min(relativeEnd, len);

            // Step 12.
            while(k < final)
            {
                O[k] = value;
                k++;
            }

            // Step 13.
            return O;
        }
    });
}

/**
 * Incremental Timeout
 *
 * Used to incrementally push back a single timeout when setTimeout is called too quickly
 *
 * @param callback
 * @param time
 * @constructor
 */
function IncrementalTimeout(callback, time)
{
    this.timeout  = null;
    this.callback = callback;
    this.time     = time;
}

IncrementalTimeout.prototype.setTimeout = function(callback, time)
{
    if(is_function(callback))
    {
        this.callback = callback;
        this.time     = time;
    }

    if(is_function(this.callback))
    {
        if(isset(this.timeout))
        {
            clearInterval(this.timeout);
        }

        this.timeout = setTimeout(this.callback, this.time);
    }
};

function refreshPage(time)
{
    setTimeout(function()
    {
        if(FTXCommon && FTXCommon.Utils && is_function(FTXCommon.Utils.showLoader))
        {
            FTXCommon.Utils.showLoader();
        }

        loadUrl(window.location.href);
    }, time);
}